import { ascending, bisect, quantileSorted as threshold } from "d3-array";
import { initRange } from "./init.js";
export default function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while (++i < n)
            thresholds[i - 1] = threshold(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[bisect(thresholds, x)];
    }
    scale.invertExtent = function (y) {
        var i = range.indexOf(y);
        return i < 0 ? [NaN, NaN] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function (_) {
        if (!arguments.length)
            return domain.slice();
        domain = [];
        for (var _i = 0, _1 = _; _i < _1.length; _i++) {
            var d = _1[_i];
            if (d != null && !isNaN(d = +d))
                domain.push(d);
        }
        domain.sort(ascending);
        return rescale();
    };
    scale.range = function (_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function (_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function () {
        return thresholds.slice();
    };
    scale.copy = function () {
        return quantile()
            .domain(domain)
            .range(range)
            .unknown(unknown);
    };
    return initRange.apply(scale, arguments);
}
